import { merge } from 'lodash-es';

const getInitialState = () => ({
  notification_settings: {
    from: null,
    alerts_severities: {},
    sender_name: null,
    email_recipients_list: null
  },
  smtp_settings: {
    smtp_server: null,
    password: null,
    connection_security: null,
    port: 587,
    account_name: null
  }
});

export default {
  namespaced: true,
  state: getInitialState,
  mutations: {
    FETCH_EMAIL_NOTIFY_SUCCESS(state, payload) {
      state.notification_settings = payload.notification_settings;
      state.smtp_settings = payload.smtp_settings;

      state.notification_settings.email_recipients_list = Array.isArray(state.notification_settings.email_recipients_list)
        ? state.notification_settings.email_recipients_list.join(', ')
        : state.notification_settings.email_recipients_list.toString();
    },
    FLUSH_STATE(state) {
      Object.assign(state, getInitialState());
    },
  },
  actions: {
    FETCH_EMAIL_NOTIFY({ commit }) {
      return this.$api.get('/api/v2/notifications').then((response) => commit('FETCH_EMAIL_NOTIFY_SUCCESS', response.data));
    },
    TEST_EMAIL_NOTIFY(context, payload) {
      return this.$api.post('/api/v2/notifications/test-email', {
        from: payload.notification_settings.from.trim(),
        sender_name: payload.notification_settings.sender_name,
        email_recipients_list: payload.notification_settings.email_recipients_list
          .split(',')
          .map(mail => mail.trim())
          .filter(mail => mail),
        smtp_server: payload.smtp_settings.smtp_server,
        password: payload.smtp_settings.password,
        connection_security: payload.smtp_settings.connection_security,
        port: payload.smtp_settings.port,
        account_name: payload.smtp_settings.account_name
      });
    },
    SAVE_EMAIL_NOTIFY({ commit }, payload) {
      const requestPayload = merge({}, payload);
      requestPayload.notification_settings.from = requestPayload.notification_settings.from.trim();
      requestPayload.notification_settings.email_recipients_list = requestPayload.notification_settings.email_recipients_list
          .split(',')
          .map(mail => mail.trim())
          .filter(mail => mail);

      return this.$api.put('/api/v2/notifications', requestPayload)
        .then((response) => {
          commit('FETCH_EMAIL_NOTIFY_SUCCESS', requestPayload);
          return response;
        });
    }
  }
};
